import { useEffect, useState } from "react";
import { useTableConfigNotice } from "../../services/config";
import { IMGBUCKETURL } from "../../DataStore/ApiConstant";

const UpiBanner = () => {
  const UPI_BANNER_LOGIN_EVENT_KEY = "upi-banner-login-event-id";
  const UPI_BANNER_SHOWN_KEY = "upi-banner-shown-for-login";
  let notice = useTableConfigNotice();
  const [active, setActive] = useState(false);
  const [image, setImage] = useState("");

  useEffect(() => {
    const loginUser = localStorage.getItem("login");

    if (!loginUser || notice.isLoading || !notice?.data?.length) {
      setActive(false);
      return;
    }

    const upiBanner = notice.data.find((item) => item.type === "upi");

    if (!upiBanner) {
      setActive(false);
      return;
    }

    let loginEventId = localStorage.getItem(UPI_BANNER_LOGIN_EVENT_KEY);
    if (!loginEventId) {
      loginEventId = `${loginUser}-${Date.now()}`;
      localStorage.setItem(UPI_BANNER_LOGIN_EVENT_KEY, loginEventId);
    }
    const shownForLogin = sessionStorage.getItem(UPI_BANNER_SHOWN_KEY);

    if (shownForLogin === loginEventId) {
      setActive(false);
      return;
    }

    sessionStorage.setItem(UPI_BANNER_SHOWN_KEY, loginEventId);
    setImage(upiBanner.image);
    setActive(true);
  }, [notice.isLoading, notice.data]);

  return (
    <>
      {active && (
        <div
          className={`modal fade ${active ? "show d-block" : ""}`}
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          style={{ backgroundColor: "#000000a1" }}
          onMouseDown={(event) => {
            if (event.target === event.currentTarget) {
              setActive(false);
            }
          }}
        >
          <div
            className="modal-dialog modal-dialog-scrollable showModalcontent"
            style={{ maxWidth: "600px", width: "95vw" }}
          >
            <div className="modal-content" style={{ backgroundColor: "transparent" }}>
              <div className="modal-header">
                <button
                  type="button"
                  className="btn-close ms-auto"
                  onClick={() => setActive(false)}
                  style={{
                    backgroundColor: "white",
                    position: "relative",
                  }}
                ></button>
              </div>
              <div className="modal-body">
                <img className="img-fluid" alt="" src={`${IMGBUCKETURL + image}`} />
              </div>
              <div className="modal-footer"></div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default UpiBanner;